export default __webpack_public_path__ + "static/media/completeProfile.e7e9f7f0.svg";